import {
  Box,
  Text,
  Link,
  List,
  ListItem,
  Image,
  Center,
  RadioGroup,
  Radio,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, { useState, useEffect } from "react";
import {
  faFilePdf,
  faBars,
  faTable,
  faSearch,
  faTruck,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import BaseLayout from "../../components/base_layout";
import Pagination from "react-js-pagination";
import Route from "../../components/common/route";
import SwiperCore, { EffectFade, Navigation } from "swiper";
import { useRouter } from "next/router";
SwiperCore.use([Navigation, EffectFade]);

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import { GetCookie } from "../../provider/common";
import Select from "react-select";
//견적바구니 개수 추가
import { useRecoilState } from "recoil";
import { quoteCntState } from "../../atoms/state";

export default function Category() {
  const router = useRouter();
  const axios = require("axios").default;
  const [keyword, setKeyword] = useState("");

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState("");
  const [data, setData] = useState("");
  const [noneSearchShow, setNoneSearchShow] = useState(false);

  const [btnActive, setBtnActive] = useState("square");
  const [isLoginCheck, setIsLoginCheck] = useState("");

  const [category, setCategory] = useState("18");
  const [sequence, setSequence] = useState("new");
  const [byName, setByName] = useState("it_time");
  const [bySort, setBySort] = useState("DESC");
  const [options, setOptions] = useState("");
  const [industry, setIndustry] = useState("");
  const [selectedManufacturer, setSelectedManufacturer] = useState(null);
  const [quoteCnt, setQuoteCnt] = useRecoilState(quoteCntState);

  useEffect(() => {
    getData();
    handleLoginCheck();
  }, [page]);

  const getData = async () => {
    let URL = `${
      process.env.PANDA_API_URL
    }/api/mall/getMarketPlace?page=${page}&offset=${perPage}&keyword=${encodeURIComponent(
      keyword
    )}&caid=${category}&orderbyname=${byName}&orderbysort=${bySort}&manufacturer=${industry}`;
    let Res = await axios.get(URL, {
      headers: {
        "content-type": "application/json",
      },
    });
    setData(Res.data.data);
    setTotalCount(Res.data.data_length);

    let manufactureURL =
      process.env.PANDA_API_URL + "/api/mall/marketplaceManufacturer";
    let manufactureRes = await axios.get(manufactureURL, {
      headers: {
        "content-type": "application/json",
      },
    });

    setOptions(manufactureRes.data.data);
  };

  const searchKeyword = (e) => {
    setPage(1);
    getData();
  };

  // 검색어 저장
  const saveKeyword = (e) => {
    setKeyword(e.target.value);
  };

  // 현재 페이지 나타내는 함수
  const handlePageChange = (page) => {
    window.scrollTo(0, 400);
    setPage(page);
  };

  const OnEnter = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await searchKeyword();
    }
  };

  const getBtnActive = (e) => {
    setBtnActive(e.target.value);
  };

  const checkCategory = async (e) => {
    // 카테고리가 변경될때마다 page 수는 1로 초기화
    setCategory(e);
    setPage(1);
    let URL = `${
      process.env.PANDA_API_URL
    }/api/mall/getMarketPlace?page=1&offset=${perPage}&keyword=${encodeURIComponent(
      keyword
    )}&caid=${e}&orderbyname=${byName}&orderbysort=${bySort}&manufacturer=${industry}`;
    let Res = await axios.get(URL, {
      headers: {
        "content-type": "application/json",
      },
    });
    setData(Res.data.data);
    setTotalCount(Res.data.data_length);
  };

  const checkSequence = async (e) => {
    if (e === "new") {
      setSequence("new");
      setByName("it_time");
      setBySort("DESC");
      let URL = `${
        process.env.PANDA_API_URL
      }/api/mall/getMarketPlace?page=${page}&offset=${perPage}&keyword=${encodeURIComponent(
        keyword
      )}&caid=${category}&orderbyname=it_time&orderbysort=DESC&manufacturer=${industry}`;
      let Res = await axios.get(URL, {
        headers: {
          "content-type": "application/json",
        },
      });
      setData(Res.data.data);
      setTotalCount(Res.data.data_length);
    } else if (e === "name_first") {
      setSequence("name_first");
      setByName("it_name");
      setBySort("ASC");
      let URL = `${
        process.env.PANDA_API_URL
      }/api/mall/getMarketPlace?page=${page}&offset=${perPage}&keyword=${encodeURIComponent(
        keyword
      )}&caid=${category}&orderbyname=it_name&orderbysort=ASC&manufacturer=${industry}`;
      let Res = await axios.get(URL, {
        headers: {
          "content-type": "application/json",
        },
      });
      setData(Res.data.data);
      setTotalCount(Res.data.data_length);
    } else if (e === "name_last") {
      setSequence("name_last");
      setByName("it_name");
      setBySort("DESC");
      let URL = `${
        process.env.PANDA_API_URL
      }/api/mall/getMarketPlace?page=${page}&offset=${perPage}&keyword=${encodeURIComponent(
        keyword
      )}&caid=${category}&orderbyname=it_name&orderbysort=DESC&manufacturer=${industry}`;
      let Res = await axios.get(URL, {
        headers: {
          "content-type": "application/json",
        },
      });
      setData(Res.data.data);
      setTotalCount(Res.data.data_length);
    }
  };

  const handleLoginCheck = async () => {
    const isLogin = await GetCookie("isLogin");
    setIsLoginCheck(isLogin);
  };

  const selectIndustry = async (e) => {
    setIndustry(e.value);
    await reactselect2fixed(e);
    let URL = `${
      process.env.PANDA_API_URL
    }/api/mall/getMarketPlace?page=${page}&offset=${perPage}&keyword=${encodeURIComponent(
      keyword
    )}&caid=${category}&orderbyname=it_name&orderbysort=DESC&manufacturer=${
      e.value
    }`;
    let Res = await axios.get(URL, {
      headers: {
        "content-type": "application/json",
      },
    });
    setData(Res.data.data);
    setTotalCount(Res.data.data_length);
  };

  // 제조사가 선택했을때 사라지는것 대비해서 고정하는 로직 추가
  const reactselect2fixed = async (e) => {
    // 최초에
    const defaultOption = options.find((opt) => opt.value === e.value);
    setSelectedManufacturer(defaultOption);
  };

  const MyComponent = () => (
    <Select
      options={options}
      value={selectedManufacturer}
      onChange={selectIndustry}
    />
  );

  const combineBotAsked = async (datum) => {
    // 로그인이 되어있지 않더라도 상세를 볼수 있게 한다. 이유는 구글 크롬에서 가져오기 위함
    const basePath = "/parts/inventory/" + datum.it_id;
    router.push(basePath);
  };

  // 몰뷰로 이동할 것인가? 컴바인봇 견적 문의하기로 할 것이냐?
  const isShoppingmallOrCombineBot = async (datum) => {
    if (datum.it_soldout === 2) {
      await combineBotAsked(datum);
    } else {
      //쇼핑몰소개
      router.push(`/parts/mallview/${datum.it_id}`);
    }
  };

  const returnCondition = async (e) => {
    let URL = `${process.env.PANDA_API_URL}/api/mall/getMarketPlace?page=1&offset=20&keyword=&caid=18&orderbyname=it_time&orderbysort=DESC&manufacturer=`;
    let Res = await axios.get(URL, {
      headers: {
        "content-type": "application/json",
      },
    });
    setData(Res.data.data);
    setTotalCount(Res.data.data_length);
    setCategory("18");
    setSequence("new");
    setIndustry("");

    let manufactureURL =
      process.env.PANDA_API_URL + "/api/mall/marketplaceManufacturer";
    let manufactureRes = await axios.get(manufactureURL, {
      headers: {
        "content-type": "application/json",
      },
    });

    await reactselect2fixed(e);
  };

  return (
    <BaseLayout>
      <Box className="mallCategory_wrap ko">
        <>
          <Box className="market-category-title">
            <Box className="category-search">
              <h1 className="market_title_img" onClick={returnCondition}></h1>

              <Box>
                <input
                  value={keyword}
                  onChange={saveKeyword}
                  placeholder="검색어를 입력하세요"
                  onKeyPress={OnEnter}
                />
                <button onClick={searchKeyword}>
                  <FontAwesomeIcon color="#fff" icon={faSearch} />{" "}
                </button>
              </Box>
            </Box>
            <Box className="category-list-btn">
              <ul>
                <li>
                  <button
                    className={`${btnActive === "square" ? " active" : ""}`}
                    value="square"
                    onClick={() => setBtnActive("square")}
                  >
                    <FontAwesomeIcon
                      className="datasheet_icon"
                      icon={faTable}
                    />{" "}
                  </button>
                </li>
                <li>
                  <button
                    className={`${btnActive === "list" ? " active" : ""}`}
                    value="list"
                    onClick={() => setBtnActive("list")}
                  >
                    <FontAwesomeIcon className="datasheet_icon" icon={faBars} />{" "}
                  </button>
                </li>
              </ul>
            </Box>
          </Box>
          <Box className="marketPlace">
            <Box className="marketPlace_category ko">
              <Box>
                <h3>카테고리</h3>
                <RadioGroup
                  defaultValue="18"
                  onChange={checkCategory}
                  value={category}
                >
                  <Radio value="18">전체</Radio>
                  <Radio value="1800">모빌리티</Radio>
                  <Radio value="1801">로보틱스</Radio>
                  <Radio value="1802">디펜스</Radio>
                  <Radio value="1803">기타</Radio>
                </RadioGroup>
              </Box>
              <Box>
                <h3>순서</h3>
                <RadioGroup
                  defaultValue="new"
                  onChange={checkSequence}
                  value={sequence}
                >
                  <Radio value="new">최신등록순</Radio>
                  <Radio value="name_first">이름순(A~Z)</Radio>
                  <Radio value="name_last">이름순(Z~A)</Radio>
                </RadioGroup>
              </Box>

              <Box className="except">
                <h3>제조사</h3>

                <MyComponent></MyComponent>
              </Box>
            </Box>
            {totalCount > 0 ? (
              <Box className="marketPlace_box">
                <Box>
                  <>
                    {btnActive === "list" ? (
                      //  table / list 형식
                      <>
                        <Box className="market_table list">
                          <Box className="market_table_header">
                            <Box className="market_header_info">제품명</Box>
                            <Box className="market_header_cnt">수량</Box>
                            <Box></Box>
                            <Box></Box>
                          </Box>
                          <ul>
                            {data
                              ? data.map((datum) => (
                                  <li className="market_table_item">
                                    <Box className="market_item_info">
                                      <Box className="market_item_img">
                                        <Link
                                          onClick={() =>
                                            isShoppingmallOrCombineBot(datum)
                                          }
                                          className="category_market_img"
                                        >
                                          {" "}
                                          <Image
                                            src={
                                              datum.it_img1
                                                ? datum.it_img1
                                                : datum.it_img2
                                                ? datum.it_img2
                                                : "/images/no_img.png"
                                            }
                                            width="100%"
                                            height="auto"
                                          />
                                        </Link>
                                      </Box>
                                      <Box className="market_item_names">
                                        <Link
                                          onClick={() =>
                                            isShoppingmallOrCombineBot(datum)
                                          }
                                        >
                                          <p>{datum.it_brand}</p>
                                          <strong>{datum.it_name}</strong>
                                          <span>{datum.it_basic}</span>
                                        </Link>
                                      </Box>
                                    </Box>

                                    <Box className="market_item_cnt">
                                      <>
                                        {datum.it_soldout === 1 ? (
                                          <p className="category_market_number">
                                            <b>재고</b>
                                            <span>0</span>
                                            <b className="unit">개</b>
                                          </p>
                                        ) : (
                                          <p className="category_market_number">
                                            <b>재고</b>
                                            <span>
                                              {datum.it_stock_qty.toLocaleString()}{" "}
                                            </span>
                                            <b className="unit">개</b>
                                          </p>
                                        )}
                                      </>
                                    </Box>

                                    <Box className="market_item_notice">
                                      <>
                                        {" "}
                                        {datum.it_soldout === 2 ? (
                                          <Box>
                                            <p className="rightNow">
                                              바로출고{" "}
                                              <FontAwesomeIcon
                                                icon={faTruck}
                                              ></FontAwesomeIcon>
                                            </p>
                                            <p className="specialPrice">
                                              특가제공{" "}
                                              <FontAwesomeIcon
                                                icon={faStar}
                                              ></FontAwesomeIcon>
                                            </p>
                                          </Box>
                                        ) : (
                                          <Box className="market_item_prices">
                                            <p className="price_before">
                                              ₩
                                              <span>
                                                {datum.prices[0].it_price_before.toLocaleString()}
                                              </span>
                                            </p>
                                            <p className="price_after">
                                              할인가 : ₩
                                              <span>
                                                {datum.prices[0].it_price.toLocaleString()}
                                              </span>
                                            </p>
                                          </Box>
                                        )}
                                      </>
                                    </Box>

                                    <Box className="market_item_btns">
                                      {datum.it_origin === null ||
                                      datum.it_origin === "null" ||
                                      datum.it_origin === "" ||
                                      datum.it_origin === undefined ||
                                      datum.it_origin === "undefined" ? (
                                        <Box className="data_sheet non">
                                          <Link isExternal="true">
                                            <FontAwesomeIcon
                                              className="datasheet_icon"
                                              icon={faFilePdf}
                                            />
                                            데이터시트
                                          </Link>
                                        </Box>
                                      ) : (
                                        <Box className="data_sheet">
                                          <Link
                                            href={datum.it_origin}
                                            isExternal="true"
                                          >
                                            <FontAwesomeIcon
                                              className="datasheet_icon"
                                              icon={faFilePdf}
                                            />
                                            데이터시트
                                          </Link>
                                        </Box>
                                      )}
                                      <Box className="buy_btn">
                                        {datum.it_soldout === 1 ? (
                                          <a
                                            className="back_order"
                                            href={`/parts/mallview/${datum.it_id}`}
                                          >
                                            Back-Order
                                          </a>
                                        ) : datum.it_soldout === 2 ? (
                                          <Box
                                            className="quote"
                                            onClick={() =>
                                              combineBotAsked(datum)
                                            }
                                          >
                                            판다봇 견적요청
                                          </Box>
                                        ) : (
                                          <a
                                            className="cart"
                                            href={`/parts/mallview/${datum.it_id}`}
                                          >
                                            구매하기
                                          </a>
                                        )}
                                      </Box>
                                    </Box>
                                  </li>
                                ))
                              : ""}
                          </ul>
                        </Box>
                      </>
                    ) : btnActive === "square" ? (
                      // grid 형식
                      <>
                        <Box className="grid mallCategory-list_container">
                          <Box className="mallCategory-list_wrap">
                            {data
                              ? data.map((datum) => (
                                  <Box className="mallCategory-grid_product">
                                    <Link
                                      onClick={() =>
                                        isShoppingmallOrCombineBot(datum)
                                      }
                                    >
                                      <Box className="mallCategory-grid_product_img">
                                        <Image
                                          src={
                                            datum.it_img1
                                              ? datum.it_img1
                                              : datum.it_img2
                                              ? datum.it_img2
                                              : "/images/no_img.png"
                                          }
                                        />
                                      </Box>
                                    </Link>
                                    <Box className="mallCategory-grid_content">
                                      <Text className="mallCategory-grid_product_name">
                                        <span> {datum.it_brand}</span>
                                        <span>{datum.it_name}</span>
                                        <span>{datum.it_basic}</span>
                                        <a></a>
                                      </Text>
                                      <Text className="mallCategory-grid_product_number">
                                        {datum.it_soldout === 1 ? (
                                          <span>재고 0 개</span>
                                        ) : (
                                          <span>
                                            재고{" "}
                                            {datum.it_stock_qty.toLocaleString()}{" "}
                                            개
                                          </span>
                                        )}

                                        {datum.it_soldout === 2 ? (
                                          <>
                                            <>
                                              <span
                                                style={{ height: "20px" }}
                                              ></span>
                                              <span
                                                style={{
                                                  textDecoration: "none",
                                                  display: "flex",
                                                }}
                                              >
                                                <span>바로출고</span>
                                                <span>특가제공</span>
                                              </span>
                                            </>
                                          </>
                                        ) : (
                                          <>
                                            {" "}
                                            <span>
                                              ₩
                                              {Math.round(
                                                datum.it_price * 0.03 +
                                                  datum.it_price
                                              ).toLocaleString()}
                                            </span>
                                            <span>
                                              할인가: ₩
                                              {datum.it_price.toLocaleString()}
                                            </span>
                                          </>
                                        )}
                                      </Text>
                                    </Box>
                                    <Box className="mallCategory-grid_product_link">
                                      {datum.it_origin === null ||
                                      datum.it_origin === "null" ||
                                      datum.it_origin === "" ||
                                      datum.it_origin === undefined ||
                                      datum.it_origin === "undefined" ? (
                                        <Link
                                          className="non-dataSheet"
                                          isExternal="true"
                                        >
                                          <Box className="datasheet">
                                            <FontAwesomeIcon
                                              className="datasheet_icon"
                                              icon={faFilePdf}
                                            />
                                            데이터시트
                                          </Box>
                                        </Link>
                                      ) : (
                                        <Link
                                          href={datum.it_origin}
                                          isExternal="true"
                                        >
                                          <Box className="datasheet">
                                            <FontAwesomeIcon
                                              className="datasheet_icon"
                                              icon={faFilePdf}
                                            />
                                            데이터시트
                                          </Box>
                                        </Link>
                                      )}

                                      {datum.it_soldout === 1 ? (
                                        <Route
                                          text="Back-Order"
                                          classProp={
                                            "mallCategory-info-list_item__goto_backOrder"
                                          }
                                          href={`/parts/mallview/${datum.it_id}`}
                                          backgroundColor="#fff"
                                          color="#E53E3E"
                                        />
                                      ) : datum.it_soldout === 2 ? (
                                        <Link
                                          className={`flex-center market_goPanda_btn`}
                                          style={{ margin: "0 5px" }}
                                        >
                                          <Box
                                            className="mallCategory-info-list_item__goto_inventory"
                                            color="#E53E3E"
                                            backgroundColor="#fff"
                                            style={{
                                              fontSize: "15px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontWeight:
                                                "var(--panda-main-font-weight)",
                                            }}
                                            onClick={() =>
                                              combineBotAsked(datum)
                                            }
                                          >
                                            판다봇 견적요청
                                          </Box>
                                        </Link>
                                      ) : (
                                        <Route
                                          text="구매하러가기"
                                          classProp={
                                            "mallCategory-info-list_item__goto"
                                          }
                                          href={`/parts/mallview/${datum.it_id}`}
                                        />
                                      )}
                                    </Box>
                                  </Box>
                                ))
                              : ""}
                          </Box>
                        </Box>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                  <></>
                </Box>
                <Pagination
                  activePage={page}
                  itemsCountPerPage={perPage}
                  totalItemsCount={totalCount}
                  pageRangeDisplayed={5}
                  prevPageText={"‹"}
                  nextPageText={"›"}
                  onChange={handlePageChange}
                />
              </Box>
            ) : totalCount === 0 ? (
              <Box className="marketPlace_box">
                <Box className="marketPlace_empty">
                  <Image
                    className="noneSearch-img"
                    src="/images/warning 1.png"
                  />
                  <span
                    style={{
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    검색결과가 없습니다.
                  </span>
                </Box>
              </Box>
            ) : (
              ""
            )}
          </Box>
        </>

        {/* ============ 검색결과 데이터가 없을때  ============*/}
        <Box className={noneSearchShow ? "search" : "search-hidden"}>
          <Center>
            <Box className="noneSearch">
              <Image className="noneSearch-img" src="/images/warning 1.png" />
              <Text className="noneSearch-result">등록된 제품이 없습니다.</Text>
            </Box>
          </Center>
        </Box>
      </Box>
    </BaseLayout>
  );
}
